import React from "react";
import {Trans} from '@lingui/macro';
import dayjs from 'dayjs';
import {DateTimeWidth} from "./CommonWidths";

export function CreatedAtTd({text}) {
    if (!text)
        return '-';

    const dateMoment = dayjs(text);
    const dateString = dateMoment.format('DD/MM/YYYY');
    const timeString = dateMoment.format('hh:mma');
    return (
        <div style={{ lineHeight: 1.2, textAlign: 'left', display: "flex"}}>
            <p>{dateString}</p>
            &nbsp;
            <p style={{ color: 'rgba(0, 0, 0, 0.4)'}}>{timeString}</p>
        </div>
    );
}

// all CreatedAt use the above component <CreatedAtTd /> now
// export function CreatedAtOneLineTd({text}){
//     if (!text)
//         return '-'

//     const dateMoment = Moment(text)
//     const dateString = dateMoment.format('DD/MM/YYYY')
//     const timeString = dateMoment.format('hh:mma')
//     return <span>{dateString} <span style={{ color: 'rgba(0, 0, 0, 0.4)'}}>{timeString}</span></span>
// }

export const CreatedAtColumn = {
    title: <Trans>Created At</Trans>,
    dataIndex: 'created_at',
    key: 'created_at',
    width: DateTimeWidth,
    align: 'left',
    ellipsis: true,
    render: text => <CreatedAtTd text={text} />,
};
